import { render, staticRenderFns } from "./MyPasswordSet.vue?vue&type=template&id=24dacea0&scoped=true&style=width%3A%2050%25&"
import script from "./MyPasswordSet.vue?vue&type=script&lang=js&"
export * from "./MyPasswordSet.vue?vue&type=script&lang=js&"
import style0 from "./MyPasswordSet.vue?vue&type=style&index=0&id=24dacea0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dacea0",
  null
  
)

export default component.exports